const calculateTotalPartsPrice = (parts) => {
    const totalPartsPrice = parts.reduce((total, part) => {
        const numberofParts = part.numberof ? parseInt(part.numberof) : 1;
        const discount = part.discount ? parseFloat(part.discount) / 100 : 0;
        const discountedPricePrPart = (part.price * (1 - discount)).toFixed(2);
        const totalPriceForParts = discountedPricePrPart * numberofParts;
        return total + totalPriceForParts;
    }, 0);

    return totalPartsPrice;
};

export default calculateTotalPartsPrice;
